import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from '@tanstack/react-router'

import { clientPortalInternalCaseInformationQuery } from '@/lib/queries/case-dashboard/v1/portal/cases/queries'
import { clientPortalRelevantCasesQuery } from '@/lib/queries/case-dashboard/v1/portal/relevant-case/queries'

export const useClientPortalInternalData = () => {
  const navigate = useNavigate()
  const { applicantId, caseId } = useParams({
    from: '/client-portal/internal/$applicantId/$caseId',
  })

  const { data: dataClientPortalInternal } = useQuery(clientPortalInternalCaseInformationQuery(Number(caseId)))
  const { data: dataAllApplicantCases } = useQuery(clientPortalRelevantCasesQuery(Number(caseId)))

  const caseNumber = dataClientPortalInternal?.caseInfo.caseNumber
  const isUscisCase = dataClientPortalInternal?.caseInfo?.applicationType === 'uscis'
  const companyId = dataClientPortalInternal?.company?.companyId

  const navigateToCaseDetail = () => {
    if (!caseNumber) {
      return
    }

    void navigate({
      to: '/applicants/$applicantId/cases/$caseNumber',
      params: {
        applicantId,
        caseNumber,
      },
    })
  }

  return {
    applicantId,
    caseId: Number(caseId),
    companyId,
    caseNumber,
    isUscisCase,
    dataClientPortalInternal,
    dataAllApplicantCases,
    navigateToCaseDetail,
  }
}
